import React from 'react'
import { News } from '../Data/News'
import { Link, useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { Icon } from 'semantic-ui-react'

export default function NewsDetails() {
  const { id } = useParams()
  const mobile = useMediaQuery({ query: '(max-width:1130px)' })

  const newsItem = News.find(item => String(item.id) === String(id))

  if (!newsItem) {
    return (
      <>
        <div
          className='pageBanner'
          style={{ height: `${mobile ? '65px' : '90px'}`, backgroundColor: '#171717' }}
        />
        <div className='newsDetailsWrapper' style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h2>News Article Not Found</h2>
          <br />
          <Link to='/news' className='newsBackLink'>
            <Icon name='arrow left' /> Back to News
          </Link>
        </div>
      </>
    )
  }

  return (
    <>
      <div
        className='pageBanner'
        style={{ height: `${mobile ? '65px' : '90px'}`, backgroundColor: '#171717' }}
      />

      <article className='newsDetailsWrapper'>
        <Link to='/news' className='newsBackLink'>
          <Icon name='arrow left' /> Back to News
        </Link>

        {newsItem.date && (
          <div className='newsMeta'>
            <span>
              <Icon name='calendar alternate outline' /> {newsItem.date}
            </span>
          </div>
        )}

        <h1 className='newsHeadline'>{newsItem.headline}</h1>

        {newsItem.image && (
          <div className='newsHeroImageContainer'>
            <img
              src={newsItem.image}
              alt={newsItem.headline}
              className='newsHeroImage'
            />
          </div>
        )}

        <div className='newsBody'>
          {newsItem.details}
        </div>

        <div className='newsFooter'>
          <Link to='/news' className='newsFooterBackBtn'>
            <Icon name='arrow left' /> Back to All News
          </Link>
        </div>
      </article>
    </>
  )
}
